<style>

</style>
<template>
<div id="skills">
   <body>

    <h3><font size="5">Key Skills</font></h3>
    <p>
     • Python • C++ • Java • Javascript • Vue.js • Web Development
     <br> • Amazon Web Services (AWS) • HTML • CSS 
     <br> • Adobe Suite • Microsoft Office Suite • Node.js
     <br> • Agile Planning • Git • Jira • Confluence •
      </p>
    <br>
    <a href="#app">Back to Top</a> 
</body>
</div>
</template>

<script>
   export default{

   }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
    background: #e9e2d5;
    padding: 30px;
}
p{
    color: black;
    font-size: 20px;

}
a {
    font-size: 15px;
    color: #ff0000;
}
</style>